<template>
  <div class="
      fixed
      confirm-order
      h-full
      w-full
      left-0
      top-0
      bottom-0
      right-0
      px-4
      bg-white
      overflow-x-hidden
    ">

    <h1 class="confirm-order__h1">{{$t('client.confirm_order.title')}}</h1>

    <div class="confirm-order__tabs">
      <button
        @click="setActiveColumn('mockup')"
        :class="{'active':activeColumn=='mockup'}"
      >3D-Макет</button>
      <button
        @click="setActiveColumn('complectation')"
        :class="{'active':activeColumn=='complectation'}"
      >Комплектация</button>
      <button
        @click="setActiveColumn('order')"
        :class="{'active':activeColumn=='order'}"
      >Заказ</button>
    </div>

    <div class="confirm-order-content">

      <div
        class="confirm-order-content-column"
        :class="{'active':activeColumn=='mockup'}"
      >
        <div class="column__title">
          {{ $t("client.confirm_order.3d_order") }}:
        </div>
        <div class="order-mockup">

          <div class="order-image">
            <img
              v-if="mockup"
              class="object-cover"
              :src="mockup"
            />
            <img
              v-else
              src="/images/spinner.svg"
              alt=""
            />
          </div>
        </div>
        <div
          class="order-faces mt-4"
          v-if="faces&&faces.length"
        >
          <div class="font-bold mb-2">
            {{ faces.length > 1 ? $t("client.confirm_order.faces_mockups") : $t("client.confirm_order.face_mockup")}}:</div>

          <div class="order-faces-list">
            <div
              class="order-faces-item"
              v-for="(face, index) in faces"
              :key="`faces-mock-${face.face_id}`"
            >
              <div class="order-faces-name text-sm">
                <span>{{ index + 1 }}</span>
                <span
                  class="order-face-name"
                  v-html="face.faceName"
                ></span>
              </div>
              <div
                @click.prevent="openFacePopup(face, index)"
                class="order-faces-image"
                :style="face.finalImage ? {backgroundImage: `url('${face.finalImage}')`} : {}"
              >
                <img 
                  v-if="!face.finalImage" 
                  src="/images/spinner.svg" 
                  alt="Загрузка макета"
                  class="mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="confirm-order-content-column"
        :class="{'active':activeColumn=='complectation'}"
      >
        <div class="column__title">
          {{ $t("client.confirm_order.order_detail") }}:
        </div>
        <div class="elements">
          <div
            v-if="plot"
            class="text-xl mb-4"
          >
            {{ plot.name }}
          </div>
          <ValidationErrors :errors="errorsFor('plot_id')" />
          <ValidationErrors :errors="errorsFor('elements')" />
          <div
            class="element-item-list"
            v-if="elements.length"
          >
            <CardElementCart
              v-for="element in elements"
              :key="`complectation-element-${element.element_id}`"
              :element="element"
              :settings="settings"
            />
          </div>
          <CardLandscapingCart
            v-if="
                            landscaping &&
                                (landscaping.borderElement ||
                                    landscaping.facing_side ||
                                    landscaping.facing_top ||
                                    landscaping.fillElement ||
                                    landscaping.fillType ||
                                    landscaping.mainElement)
                        "
            class="mb-4 border-blue-top"
            :landscaping="landscaping"
            :settings="settings"
          />

          <div
            v-if="barrier"
            class="text-xl mb-4 border-blue-top element-item-list"
          >
            <card-barrier-cart
              :barrier="barrier"
              :settings="settings"
            />
          </div>
          <CardEngravingCart
            v-if="faces && faces.length"
            class="mb-4 border-blue-top"
            :faces="faces"
            :settings="settings"
            :isComplectation="false"
          />
        </div>
      </div>

      <div
        class="confirm-order-content-column"
        :class="{'active':activeColumn=='order'}"
      >
        <div class="column__title">
          {{ $t("client.confirm_order.title") }}
        </div>
        <div class="flex justify-between mb-5">
          <button
            class="btn_client btn_client-green btn_client-small"
            @click="$emit('edit-order')"
          >
            {{ $t("client.confirm_order.edit") }}
          </button>
          <button
            v-if="settings.show_delete_button_client_confirm_order==1"
            class="btn_client btn_client-red btn_client-small"
            @click="clearOrder"
          >
            {{ $t("client.confirm_order.delete") }}
          </button>
        </div>

        <div
          class="order-total"
          v-if="
                       ( settings.sale != 'no' ||
                            settings.sale == 'individual' ||
                            (settings.sale != 'individual' && sale > 0))&&settings.with_calc_price == 1
                    "
        >
          <div class="font-bold mb-2">
            {{ $t("client.confirm_order.sales") }}
          </div>
          <div
            class="text-sm"
            v-if="settings.sale == 'no'"
          >
            {{ $t("client.confirm_order.not_sales") }}
          </div>
          <div
            class="text-sm"
            v-if="settings.sale == 'individual'"
          >
            {{ $t("client.confirm_order.info_individual_sale") }}
          </div>
          <div
            class="text-sm"
            v-if="settings.sale == 'sale_with_order' && sale > 0"
          >
            {{ $t("client.confirm_order.your_sale") }}
            {{
                            settings.constructor_sale_with_order_percent_value
                        }}% ({{ $toCurrency(sale) }})
          </div>
          <div
            class="text-sm"
            v-if="
                            settings.sale == 'sale_with_order_from' && sale > 0
                        "
          >
            {{ $t("client.confirm_order.your_sale") }}
            {{
                            settings.constructor_sale_with_order_percent_from_value
                        }}% ({{ $toCurrency(sale) }})
          </div>
          <div
            class="text-sm"
            v-if="
                            settings.sale == 'sale_with_order_season' &&
                                sale > 0
                        "
          >
            {{ $t("client.confirm_order.your_sale") }}
            {{
                            settings.constructor_sale_with_order_percent_season_value
                        }}% ({{ $toCurrency(sale) }})
          </div>
        </div>

        <div
          class="order-total"
          v-if="settings.with_calc_price == 1"
        >
          <div class="font-bold mb-2">
            {{ $t("client.confirm_order.cost_orientir") }}:
          </div>

          <div v-if="sale && totalWithSale">
            <div class="text-sm line-through text-gray-400">
              {{ $toCurrency(total) }}
            </div>
            <div class="text-6xl flex items-center gap-4">
              <span>{{ $toCurrency(totalWithSale) }}</span>
              <InformerApproximatePrice />
            </div>
          </div>
          <div v-else>
            <div class="text-6xl flex items-center gap-4">
              <span>{{ $toCurrency(total) }}</span>
              <InformerApproximatePrice />
            </div>

          </div>

          <div
            class="cost-value order_prepaid"
            v-if="settings.prepaid=='1'"
          >
            <div class="order_prepaid__title text-sm">
              {{ $t("client.confirm_order.prepaid") }}:
            </div>
            <div class="order_prepaid__value text-lg">
              {{ $toCurrency(prepaid) }}
            </div>
          </div>

          <div class="order_weight">
            <div class="order_weight__title text-sm">
              {{ $t("client.confirm_order.weight_main_element") }}:
            </div>
            <div class="order_weight__value text-xl">
              {{ $toWeight(weight) }} кг
            </div>
          </div>
        </div>
        <div
          class="order-total"
          v-else
        >
          {{ $t("main.cost_manager") }}
          <div class="order_weight">
            <div class="order_weight__title text-sm">
              {{ $t("client.confirm_order.weight_main_element") }}:
            </div>
            <div class="order_weight__value text-xl">
              {{ $toWeight(weight) }} кг
            </div>
          </div>
        </div>

        <div class="order-total">
          <div class="font-bold mb-2">
            {{ $t("client.confirm_order.need_service") }}
          </div>
          <div class="additional_service">
            <div v-if="settings.use_install == 1">

              <div
                class="text-sm mb-2"
                v-if="parseInt(settings.landscaping_auto_install)&&landscaping.mainElement"
              >
                Так как присутствует Благоустройство, Установка добавляется по-умолчанию. Её нельзя исключить, можно только выбрать вариант Установки
              </div>

              <div
                v-else
                class="flex mt-4 gap-2 items-center"
              >
                <button
                  class="rounded flex items-center focus:outline-none gap-2"
                  @click="changeUseInstall"
                >
                  <span class="check"><i
                      v-if="form.use_install == 1"
                      class="fas fa-check text-red-500"
                    ></i></span>
                  <span class="text-sm">{{
                                        $t("client.confirm_order.install")
                                    }}</span>
                </button>
                <hint :textHint="
                                        $t('client.confirm_order.need_install')
                                    " />
              </div>
              <div
                class="mt-4 pl-4"
                v-if="
                                    additionalWorks &&
                                        additionalWorks.install &&
                                        additionalWorks.install.length
                                "
              >
                <div
                  class="flex justify-between items-baseline mb-2"
                  v-for="install in additionalWorks.install"
                  :key="`install-${install.id}`"
                >
                  <div class="text-sm flex items-center gap-2">
                    <input
                      type="radio"
                      name="install"
                      ref="installVariants"
                      v-model="form.install_id"
                      :value="install.id"
                      :id="`radio-install-${install.id}`"
                      @change="changeInstallId(install)"
                    />
                    <label :for="`radio-install-${install.id}`">{{ install.name }}</label>
                    <Hint
                      v-if="
                                                install.description ||
                                                    install.image
                                            "
                      :description="install.description"
                      :image="install.image"
                    />
                  </div>
                  <div v-if="settings.with_calc_price == 1">
                    <label :for="`radio-install-${install.id}`">{{
                                                $toCurrency(install.price)
                                            }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="addedElementsInstallTotal && settings.with_calc_price == 1"
              class="mt-4 pl-4 flex gap-4 justify-between"
            >
              <span class="font-semibold text-sm">
                {{
                                    $t(
                                        "client.confirm_order.additional_cost_elements"
                                    )
                                }}</span>
              <span>{{ $toCurrency(addedElementsInstallTotal) }}</span>
            </div>

            <div
              v-if="barrier && barrier.final_price_installation && settings.with_calc_price == 1"
              class="mt-4 pl-4 flex gap-4 justify-between"
            >
              <span class="font-semibold text-sm">
                {{
                                    $t(
                                        "client.confirm_order.additional_cost_barrier"
                                    )
                                }}</span>
              <span>{{ $toCurrency(barrier.final_price_installation) }}</span>
            </div>

            <div
              class="flex mt-4 gap-2 items-center"
              v-if="settings.shipping == 1"
            >
              <button
                class="rounded flex items-center focus:outline-none gap-2"
                @click="toggleShipping"
              >
                <span class="check"><i
                    v-if="form.shipping == 1"
                    class="fas fa-check text-red-500"
                  ></i></span>
                <span class="text-sm">{{
                                    $t("client.confirm_order.shipping")
                                }}</span>
              </button>
              <hint
                v-if="settings.show_conditions_shipping == 1"
                :textHint="settings.conditions_shipping_value"
              />
            </div>
            <div
              class="flex mt-4 gap-2 items-center"
              v-if="settings.winter_storage == 1"
            >
              <button
                class="rounded flex items-center focus:outline-none gap-2"
                @click="
                                    form.winter_storage =
                                        form.winter_storage == 1 ? 0 : 1
                                "
              >
                <span class="check"><i
                    v-if="form.winter_storage == 1"
                    class="fas fa-check text-red-500"
                  ></i></span>
                <span class="text-sm">{{
                                    $t("client.confirm_order.winter_storage")
                                }}</span>
              </button>
              <hint
                v-if="settings.show_conditions_storage == 1"
                :textHint="settings.conditions_storage_value"
              />
            </div>
          </div>
        </div>

        <div class="order-total form customer-form mb-6">
          <div class="font-bold mb-2">
            {{ $t("client.confirm_order.place_order") }}:
          </div>
          <p class="mb-4 text-sm">
            {{ $t("client.confirm_order.leave_contacts") }}
          </p>
          <div
            class="form-group text-sm"
            v-if="settings.show_form_confirm_order_name==1"
          >
            <label for="name">{{
                                $t("client.confirm_order.contact_name")
                            }}<span
                class="text-red-400"
                v-if="settings.required_form_confirm_order_name==1"
              >*</span>:</label>
            <div>
              <input
                id="name"
                type="text"
                v-model="form.name"
              />
            </div>
            <ValidationErrors :errors="errorsFor('name')" />
          </div>
          <div
            class="form-group text-sm"
            v-if="settings.show_form_confirm_order_phone==1"
          >
            <label for="phone">{{
                                $t("client.confirm_order.contact_phone")
                            }}<span
                class="text-red-400"
                v-if="settings.required_form_confirm_order_phone==1"
              >*</span>:</label>
            <div>
              <input
                id="phone"
                type="text"
                v-model="form.phone"
              />
            </div>
            <ValidationErrors :errors="errorsFor('phone')" />
          </div>
          <div
            class="form-group text-sm"
            v-if="settings.show_form_confirm_order_email==1"
          >
            <label for="email">{{
                                $t("client.confirm_order.contact_email")
                            }}<span
                class="text-red-400"
                v-if="settings.required_form_confirm_order_email==1"
              >*</span>:</label>
            <div>
              <input
                id="email"
                type="text"
                v-model="form.email"
              />
            </div>
            <ValidationErrors :errors="errorsFor('email')" />
          </div>
          <div
            class="form-group text-sm"
            v-if="settings.shipping==1 && settings.show_field_shipping_info==1&&
            form.shipping==1"
          >
            <label for="shipping_info">{{ settings.label_field_shipping_info || $t("admin.views.settings.label_confirm_shipping") }}<span
                class="text-red-400"
                v-if="settings.field_shipping_info_required==1"
              >*</span>:</label>
            <div>
              <textarea
                id="shipping_info"
                v-model="form.shipping_info"
              ></textarea>
            </div>
            <ValidationErrors :errors="errorsFor('shipping_info')" />
          </div>
          <div
            class="form-group text-sm"
            v-if="settings.show_form_confirm_order_comment==1"
          >
            <label for="comment">{{ $t("client.confirm_order.comment") }}<span
                class="text-red-400"
                v-if="settings.required_form_confirm_order_comment==1"
              >*</span>:</label>
            <div>
              <textarea
                id="comment"
                v-model="form.comment"
              ></textarea>
            </div>
            <ValidationErrors :errors="errorsFor('comment')" />
          </div>
          <div class="form-group text-sm">
            <button
              class="rounded flex items-center focus:outline-none gap-2"
              @click="form.accept = form.accept == 1 ? 0 : 1"
            >
              <span class="check"><i
                  v-if="form.accept == 1"
                  class="fas fa-check text-red-500"
                ></i></span>
              <span class="text-sm label-politic">Принимаю
                <span @click="showPolitic">политику конфиденциальности</span></span>
            </button>
            <ValidationErrors :errors="errorsFor('accept')" />
          </div>
        </div>

        <div>
          <div v-if="saving">Идет сохранение ...</div>
          <button
            v-else
            class="rounded bg-green-500 text-white px-4 py-2"
            @click="confirmOrder"
          >
            {{ $t("client.confirm_order.send_manager") }}
          </button>
        </div>
      </div>
    </div>

    <ClientModal
      v-if="politic"
      @close-modal="politic = null"
    >
      <template #header>
        <span class="show-page-title">{{ politic.title }}</span>
      </template>

      <div
        class="show-page-content h-full overflow-x-hidden pb-12"
        v-html="politic.content"
      ></div>
    </ClientModal>
    <ClientModal
      v-if="popupFace"
      @close-modal="closeFacePopup"
      class="popupFace"
      propWidth="auto"
      propHeight="auto"
    >
      <template #header>
        <div class="show-page-title">
          <span>{{ popupFaceIndex !== null ? popupFaceIndex + 1 + '.' : '' }}</span>
          <span class="order-face-name" v-html="popupFace.faceName"></span>
        </div>
      </template>

      <div
        class="order-face-popup-image"
        :style="popupFace.finalImage ? { backgroundImage: `url(${popupFace.finalImage})` } : {}"
      >
        <img 
          v-if="!popupFace.finalImage" 
          src="/images/spinner.svg" 
          alt="Загрузка макета"
          class="mx-auto"
        />
      </div>
    </ClientModal>
  </div>
</template>
<script>
import validationErrors from "../../mixins/validationErrors";
import Hint from "../../shared/components/Hint.vue";
import CardBarrierCart from "../General/CardBarrierCart.vue";
import CardElementCart from "../General/CardElementCart.vue";
import CardLandscapingCart from "../General/CardLandscapingCart.vue";
import CardEngravingCart from "../General/CardEngravingCart.vue";
export default {
  components: {
    Hint,
    CardElementCart,
    CardBarrierCart,
    CardLandscapingCart,
    CardEngravingCart,
  },
  name: "ConfirmOrder",
  mixins: [validationErrors],
  data() {
    return {
      politic: "",
      popupFace: null,
      popupFaceIndex: null,
      saving: false,
      activeColumn: "mockup",
      form: {
        name: "",
        phone: "",
        email: "",
        shipping: 0,
        winter_storage: 0,
        use_install: 0,
        install_id: 0,
        shipping_info: "",
        comment: "",
        accept: 0,
      },
    };
  },

  async created() {
    const installs = await this.$store.dispatch(
      "clientAdditionalWorks/fetch",
      "install"
    );

    if (this.installInOrder) {
      this.form.use_install = 1;
      this.form.install_id = this.installInOrder.id;
    } else if (
      parseInt(this.settings.landscaping_auto_install) &&
      this.landscaping.mainElement &&
      installs.length
    ) {
      let installIndex = 0;

      if (this.settings.landscaping_auto_install_id) {
        const findIndex = installs.findIndex(
          (i) => i.id == this.settings.landscaping_auto_install_id
        );
        if (findIndex > -1) {
          installIndex = findIndex;
        }
      }
      this.$store.dispatch("clientAdditionalWorks/selectAdditionalWork", {
        type: "install",
        additionalWork: installs[installIndex],
      });
      this.form.install_id = installs[installIndex].id;
      this.form.use_install = 1;
    }
  },
  beforeRouteLeave(to, from, next) {
    // Очищаем флаг при уходе со страницы, чтобы не было проблем при повторных переходах
    sessionStorage.removeItem('justCameFromConfirm');
    next();
  },
  async mounted() {
    if (this.settings.field_shipping_info_required == 1) {
      this.form.shipping = 1;
    }
    
    // Проверяем, не пришли ли мы только что со страницы /confirm
    // Используем sessionStorage для отслеживания перехода
    const justCameFromConfirm = sessionStorage.getItem('justCameFromConfirm') === 'true';
    
    if (justCameFromConfirm) {
      // Очищаем флаг
      sessionStorage.removeItem('justCameFromConfirm');
      console.log('Came from /confirm, skipping redirect check');
      
      // Даем больше времени для обновления store после генерации макетов
      // cacheOrder может быть асинхронным
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Проверяем store напрямую, а не через computed свойство
      const allFaces = this.$store.state.clientOrder.faces;
      console.log('All faces in store:', allFaces.map(f => ({
        face_id: f.face_id,
        faceName: f.faceName,
        hasElements: !!(f.elements && f.elements.length > 0),
        hasTexts: !!(f.texts && f.texts.length > 0),
        hasFinalImage: !!f.finalImage,
        finalImageLength: f.finalImage ? f.finalImage.length : 0
      })));
      
      const facesWithContent = allFaces.filter(
        face => (face.elements && face.elements.length > 0) || (face.texts && face.texts.length > 0)
      );
      
      // Проверяем наличие finalImage для каждой грани
      const facesWithoutImage = facesWithContent.filter(face => {
        const hasImage = face.finalImage && 
                        face.finalImage.length > 100 && 
                        face.finalImage.startsWith('data:image');
        
        if (!hasImage) {
          console.warn(`Face ${face.face_id} (${face.faceName || 'unnamed'}) missing finalImage:`, {
            hasFinalImage: !!face.finalImage,
            finalImageLength: face.finalImage ? face.finalImage.length : 0,
            finalImagePrefix: face.finalImage ? face.finalImage.substring(0, 50) : 'null',
            finalImageValid: face.finalImage ? face.finalImage.startsWith('data:image') : false
          });
        } else {
          console.log(`Face ${face.face_id} (${face.faceName || 'unnamed'}) has valid finalImage, size: ${(face.finalImage.length / 1024).toFixed(2)} KB`);
        }
        return !hasImage;
      });
      
      if (facesWithoutImage.length > 0) {
        const faceNames = facesWithoutImage.map(f => f.faceName || f.face_id).join(', ');
        console.warn(`Still ${facesWithoutImage.length} faces without images after coming from /confirm:`, faceNames);
        
        // Показываем предупреждение пользователю
        this.$store.dispatch("notification/add", {
          type: "warning",
          message: `Не удалось сгенерировать макеты для ${facesWithoutImage.length} граней: ${faceNames}. Вы можете продолжить оформление заказа или вернуться на страницу подтверждения для повторной генерации.`
        }, { root: true });
      } else {
        console.log('All faces have finalImage after coming from /confirm');
      }
      return;
    }
    
    // Даем время для обновления store
    await this.$nextTick();
    await new Promise(resolve => setTimeout(resolve, 300));
    
    // Проверяем, есть ли грани с элементами/текстами, но без finalImage
    const facesWithContent = this.faces.filter(
      face => (face.elements && face.elements.length > 0) || (face.texts && face.texts.length > 0)
    );
    const facesWithoutImage = facesWithContent.filter(face => !face.finalImage);
    
    // Если есть грани без изображений, перенаправляем на /confirm для генерации макетов
    if (facesWithoutImage.length > 0) {
      console.log(`Found ${facesWithoutImage.length} faces without images, redirecting to /confirm`);
      const notification = {
        type: "info",
        message: "Необходимо сгенерировать макеты граней. Переход на страницу подтверждения..."
      };
      this.$store.dispatch("notification/add", notification, { root: true });
      
      // Перенаправляем на /confirm для генерации макетов (имя роута с большой буквы)
      this.$router.push({ name: "Confirm" });
    } else {
      console.log('All faces have finalImage, no redirect needed');
    }
  },
  computed: {
    orderToSave() {
      return this.$store.getters["clientOrder/orderToSave"];
    },
    settings() {
      return this.$store.state.settings.settings;
    },
    additionalWorks() {
      return this.$store.state.clientAdditionalWorks.additionalWorks;
    },
    installInOrder() {
      return this.$store.state.clientOrder.additionalWorks.install;
    },
    renderer() {
      return this.$store.state.clientOrder.renderer;
    },
    mockup() {
      return this.$store.state.clientOrder.mockup;
    },

    plot() {
      return this.$store.state.clientOrder.plot;
    },
    elements() {
      return this.$store.state.clientOrder.elements;
    },
    landscaping() {
      return this.$store.state.clientOrder.landscaping;
    },
    weight() {
      return this.$store.state.clientOrder.weight;
    },
    total() {
      return this.$store.state.clientOrder.total;
    },
    totalCost() {
      return this.$store.state.clientOrder.totalCost;
    },
    prepaid() {
      if (this.settings.prepaid_type == "fix") {
        return parseFloat(this.settings.prepaid_type_fix_value);
      }
      if (this.settings.prepaid_type == "percent_total_price") {
        // prepaid_type_percent_total_price_value
        const prepaid =
          parseFloat(this.total) *
          (parseFloat(this.settings.prepaid_type_percent_total_price_value) /
            100);
        return prepaid;
      }
      if (this.settings.prepaid_type == "percent_total_cost") {
        // prepaid_type_percent_total_cost_value
        const prepaid =
          parseFloat(this.totalCost) *
          (parseFloat(this.settings.prepaid_type_percent_total_cost_value) /
            100);
        return prepaid;
      }
      return 0;
    },
    addedElementsInstallTotal() {
      return this.$store.state.clientOrder.addedElementsInstallTotal;
    },
    barrier() {
      return this.$store.state.clientOrder.barrier;
    },
    faces() {
      return this.$store.state.clientOrder.faces.filter(
        (f) => f.elements.length > 0 || f.texts.length > 0
      );
    },
    sale() {
      if (
        this.settings.sale == "sale_with_order" &&
        parseFloat(this.settings.constructor_sale_with_order_percent_value)
      ) {
        return (
          (this.total *
            parseFloat(
              this.settings.constructor_sale_with_order_percent_value
            )) /
          100
        );
      }

      if (
        this.settings.sale == "sale_with_order_from" &&
        parseFloat(
          this.settings.constructor_sale_with_order_percent_from_value
        ) &&
        this.total >=
          parseFloat(this.settings.constructor_sale_with_order_total_from_value)
      ) {
        return (
          (this.total *
            parseFloat(
              this.settings.constructor_sale_with_order_percent_from_value
            )) /
          100
        );
      }

      if (
        this.settings.sale == "sale_with_order_season" &&
        parseFloat(
          this.settings.constructor_sale_with_order_percent_season_value
        )
      ) {
        const dateStart = new Date(
          this.settings.constructor_sale_with_order_percent_season_value_start_date
        );
        const dateFinish = new Date(
          this.settings.constructor_sale_with_order_percent_season_value_finish_date
        );
        const currentDate = new Date();

        if (currentDate <= dateFinish && currentDate >= dateStart) {
          return (
            (this.total *
              parseFloat(
                this.settings.constructor_sale_with_order_percent_season_value
              )) /
            100
          );
        }
      }

      return null;
    },
    totalWithSale() {
      if (this.sale) {
        return this.total - this.sale;
      }
      return null;
    },
  },
  methods: {
    setActiveColumn(column) {
      this.activeColumn = column;
    },
    openFacePopup(face, index) {
      this.popupFace = face;
      this.popupFaceIndex = index;
    },
    closeFacePopup() {
      this.popupFace = null;
      this.popupFaceIndex = null;
    },
    toggleShipping() {
      if (this.settings.field_shipping_info_required == 1) {
        this.form.shipping = 1;
      } else {
        this.form.shipping = this.form.shipping == 1 ? 0 : 1;
      }
    },
    clearOrder() {
      if (
        window.confirm(this.$t("client.confirm_order.are_you_shure_delete"))
      ) {
        this.$store.dispatch("clientOrder/clear");
        location.href = "/";
      }
    },
    async showPolitic() {
      try {
        const res = await axios.get(`/api/pages/1`);
        this.politic = res.data;
      } catch (error) {
        const notification = {
          element: "error",
          message:
            error.response &&
            error.response.data &&
            error.response.data.message,
        };
        this.$store.dispatch("notification/add", notification, {
          root: true,
        });
      }
    },
    changeInstallId(install) {
      this.$store.dispatch("clientAdditionalWorks/selectAdditionalWork", {
        type: "install",
        additionalWork: install,
      });
      this.form.use_install = 1;
    },
    changeUseInstall() {
      if (
        this.landscaping.mainElement &&
        parseInt(this.settings.landscaping_auto_install)
      ) {
        this.form.use_install = 1;
        return true;
      }
      this.form.use_install = this.form.use_install == 1 ? 0 : 1;
      if (this.form.use_install == 0) {
        this.$store.dispatch(
          "clientAdditionalWorks/unSelectAdditionalWork",
          "install"
        );
        this.form.install_id = 0;
      }
    },
    async confirmOrder() {
      this.errors = null;
      this.saving = true;

      try {
        let formDataPost = new FormData();

        formDataPost.append("name", this.form.name);
        formDataPost.append("phone", this.form.phone);
        formDataPost.append("email", this.form.email);
        formDataPost.append("comment", this.form.comment);
        formDataPost.append("shipping_info", this.form.shipping_info);
        formDataPost.append("accept", this.form.accept);

        if (this.orderToSave) {
          formDataPost.append("order_cache", this.orderToSave);
        }

        if (this.form.shipping !== null) {
          formDataPost.append("shipping", parseInt(this.form.shipping));
        }
        if (this.form.use_install !== null) {
          formDataPost.append("use_install", parseInt(this.form.use_install));
          if (this.form.install_id !== null) {
            formDataPost.append("install_id", parseInt(this.form.install_id));
          }
          if (this.addedElementsInstallTotal) {
            formDataPost.append(
              "additional_cost_install_elements",
              parseFloat(this.addedElementsInstallTotal)
            );
          }
        }

        if (this.settings.sale !== "no") {
          formDataPost.append("type_sale", this.settings.sale);
          if (this.sale) {
            formDataPost.append("sale", this.sale);
          }
          if (this.totalWithSale) {
            formDataPost.append("total_with_sale", this.totalWithSale);
          }
        }

        if (this.form.winter_storage !== null) {
          formDataPost.append(
            "winter_storage",
            parseInt(this.form.winter_storage)
          );
        }

        if (this.plot !== null) {
          formDataPost.append("plot_name", this.plot.name);
          formDataPost.append("plot_width", this.plot.width);
          formDataPost.append("plot_length", this.plot.length);
        }

        if (this.barrier !== null) {
          //   formDataPost.append("barrier_id", this.barrier.element_id);
          formDataPost.append("barrier[barrier_id]", this.barrier.element_id);
          formDataPost.append("barrier[kalitka]", this.barrier.kalitka);
          formDataPost.append("barrier[perimetr]", this.barrier.perimetr);
          formDataPost.append("barrier[sizes]", this.barrier.sizes);
          formDataPost.append("barrier[total]", this.barrier.total);
          formDataPost.append("barrier[total_cost]", this.barrier.totalCost);
          formDataPost.append(
            "barrier[final_price_installation]",
            this.barrier.final_price_installation
          );
          formDataPost.append(
            "barrier[final_cost_installation]",
            this.barrier.final_cost_installation
          );
          //если выбрано положение калитки по центру
          let price_add_stolbik = 0;
          let cost_add_stolbik = 0;
          if (
            this.barrier.doorPosition &&
            this.barrier.doorPosition.wherePlace == "placeCenter" &&
            this.barrier.price_add_stolbik
          ) {
            price_add_stolbik = this.barrier.price_add_stolbik;
            cost_add_stolbik = this.barrier.cost_add_stolbik;
          }
          formDataPost.append("barrier[price_add_stolbik]", price_add_stolbik);
          formDataPost.append("barrier[cost_add_stolbik]", cost_add_stolbik);
        }

        if (this.total !== null) {
          formDataPost.append("total", this.total);
        }
        if (this.totalCost !== null) {
          formDataPost.append("total_cost", this.totalCost);
        }

        if (this.prepaid !== null) {
          formDataPost.append("prepaid", this.prepaid);
        }

        if (this.weight !== null) {
          formDataPost.append("weight", this.weight);
        }

        // const imgData = this.renderer.domElement.toDataURL("image/jpeg");
        if (this.mockup) {
          formDataPost.append(`mockup`, this.mockup);
        }

        if (this.elements.length) {
          for (const key in this.elements) {
            formDataPost.append(
              `elements[${key}][element_id]`,
              this.elements[key]["element_id"]
            );

            formDataPost.append(
              `elements[${key}][name]`,
              this.elements[key]["name"]
            );
            formDataPost.append(
              `elements[${key}][article]`,
              this.elements[key]["article"]
            );
            if (this.elements[key]["material"]) {
              formDataPost.append(
                `elements[${key}][element_material_id]`,
                this.elements[key]["material"]["material_id"]
              );
              formDataPost.append(
                `elements[${key}][material_name]`,
                this.elements[key]["material"]["name"]
              );
              formDataPost.append(
                `elements[${key}][material_coef]`,
                this.elements[key]["material"]["cost_coefficient"]
              );
            }
            if (this.elements[key]["size"]) {
              formDataPost.append(
                `elements[${key}][element_size_id]`,
                this.elements[key]["size"]["element_size_id"]
              );
              formDataPost.append(
                `elements[${key}][width]`,
                this.elements[key]["size"]["width"]
              );
              formDataPost.append(
                `elements[${key}][height]`,
                this.elements[key]["size"]["height"]
              );
              formDataPost.append(
                `elements[${key}][depth]`,
                this.elements[key]["size"]["length"]
              );
              formDataPost.append(
                `elements[${key}][size_coef]`,
                this.elements[key]["size"]["cost_coefficient"]
              );
              formDataPost.append(
                `elements[${key}][size_price]`,
                this.elements[key]["size"]["price"]
              );
              formDataPost.append(
                `elements[${key}][size_cost]`,
                this.elements[key]["size"]["cost"]
              );
              formDataPost.append(
                `elements[${key}][weight]`,
                this.elements[key]["size"]["weight"]
              );

              if (this.elements[key].polish) {
                formDataPost.append(
                  `elements[${key}][polish][id]`,
                  this.elements[key].polish.id
                );
                formDataPost.append(
                  `elements[${key}][polish][name]`,
                  this.elements[key].polish.name
                );
                formDataPost.append(
                  `elements[${key}][polish][description]`,
                  this.elements[key].polish.description
                );
                formDataPost.append(
                  `elements[${key}][polish][price]`,
                  this.elements[key].polish.price
                );
                formDataPost.append(
                  `elements[${key}][polish][cost]`,
                  this.elements[key].polish.cost
                );
              }

              if (
                this.elements[key].services &&
                this.elements[key].services.length
              ) {
                for (const service of this.elements[key].services) {
                  formDataPost.append(
                    `elements[${key}][services][${service.id}][id]`,
                    service.id
                  );
                  formDataPost.append(
                    `elements[${key}][services][${service.id}][name]`,
                    service.name
                  );
                  formDataPost.append(
                    `elements[${key}][services][${service.id}][price]`,
                    service.price
                  );
                  formDataPost.append(
                    `elements[${key}][services][${service.id}][cost]`,
                    service.cost
                  );
                }
              }
            }

            formDataPost.append(
              `elements[${key}][type]`,
              this.elements[key]["type_name"]
            );
            if (
              this.elements[key]["total"] &&
              this.elements[key]["total"] != "undefined"
            ) {
              formDataPost.append(
                `elements[${key}][total]`,
                this.elements[key]["total"]
              );
            }
            if (
              this.elements[key]["totalCost"] &&
              this.elements[key]["totalCost"] != "undefined"
            ) {
              formDataPost.append(
                `elements[${key}][total_cost]`,
                this.elements[key]["totalCost"]
              );
            }
          }
        }

        //add landscaping
        if (this.landscaping) {
          for (const key in this.landscaping) {
            if (
              Object.hasOwnProperty.call(this.landscaping, key) &&
              this.landscaping[key] !== null &&
              Object.hasOwnProperty.call(this.landscaping[key], "element_id")
            ) {
              formDataPost.append(
                `landscaping[${key}][element_id]`,
                this.landscaping[key]["element_id"]
              );
              formDataPost.append(
                `landscaping[${key}][element_group_id]`,
                this.landscaping[key]["element_group_id"]
              );
              formDataPost.append(
                `landscaping[${key}][element_group_name]`,
                this.landscaping[key]["element_group_name"]
              );
              formDataPost.append(
                `landscaping[${key}][element_group_slug]`,
                this.landscaping[key]["element_group_slug"]
              );
              formDataPost.append(
                `landscaping[${key}][price_preparation]`,
                this.landscaping[key]["price_preparation"]
              );
              formDataPost.append(
                `landscaping[${key}][base_price_preparation]`,
                this.landscaping[key]["base_price_preparation"]
              );
              formDataPost.append(
                `landscaping[${key}][cost_preparation]`,
                this.landscaping[key]["cost_preparation"]
              );
              formDataPost.append(
                `landscaping[${key}][base_cost_preparation]`,
                this.landscaping[key]["base_cost_preparation"]
              );
              formDataPost.append(
                `landscaping[${key}][facing]`,
                this.landscaping[key]["facing"]
              );

              formDataPost.append(
                `landscaping[${key}][name]`,
                this.landscaping[key]["name"]
              );

              formDataPost.append(
                `landscaping[${key}][article]`,
                this.landscaping[key]["article"]
              );

              formDataPost.append(
                `landscaping[${key}][individual_size_material]`,
                this.landscaping[key]["individual_size_material"]
              );
              formDataPost.append(
                `landscaping[${key}][perimeter]`,
                this.landscaping[key]["perimeter"]
              );
              formDataPost.append(
                `landscaping[${key}][square]`,
                this.landscaping[key]["square"]
              );
              formDataPost.append(
                `landscaping[${key}][thickness]`,
                this.landscaping[key]["thickness"]
              );
              formDataPost.append(
                `landscaping[${key}][volume]`,
                this.landscaping[key]["volume"]
              );
              formDataPost.append(`landscaping[${key}][position]`, key);

              if (this.landscaping[key]["size"]) {
                formDataPost.append(
                  `landscaping[${key}][element_size_id]`,
                  this.landscaping[key]["size"]["element_size_id"]
                );
                formDataPost.append(
                  `landscaping[${key}][width]`,
                  this.landscaping[key]["size"]["width"]
                );
                formDataPost.append(
                  `landscaping[${key}][height]`,
                  this.landscaping[key]["size"]["height"]
                );
                formDataPost.append(
                  `landscaping[${key}][length]`,
                  this.landscaping[key]["size"]["length"]
                );
                formDataPost.append(
                  `landscaping[${key}][depth]`,
                  this.landscaping[key]["size"]["depth"]
                );

                formDataPost.append(
                  `landscaping[${key}][size_price]`,
                  this.landscaping[key]["size"]["price"]
                );
                formDataPost.append(
                  `landscaping[${key}][size_cost]`,
                  this.landscaping[key]["size"]["cost"]
                );
                formDataPost.append(
                  `landscaping[${key}][weight]`,
                  this.landscaping[key]["size"]["weight"]
                );
              }

              formDataPost.append(
                `landscaping[${key}][type]`,
                this.landscaping[key]["type_name"]
              );

              formDataPost.append(
                `landscaping[${key}][fact_sizes]`,
                this.landscaping[key]["fact_sizes"]
              );

              if (
                this.landscaping[key]["total"] &&
                this.landscaping[key]["total"] != "undefined"
              ) {
                formDataPost.append(
                  `landscaping[${key}][total]`,
                  this.landscaping[key]["total"]
                );
              }
              if (
                this.landscaping[key]["totalCost"] &&
                this.landscaping[key]["totalCost"] != "undefined"
              ) {
                formDataPost.append(
                  `landscaping[${key}][total_cost]`,
                  this.landscaping[key]["totalCost"]
                );
              }
            }
          }
        }
        // end add landscaping

        if (this.faces.length) {
          for (const key in this.faces) {
            formDataPost.append(
              `faces[${key}][name]`,
              this.faces[key]["faceName"]
            );
            formDataPost.append(
              `faces[${key}][total]`,
              this.faces[key]["total"]
            );
            formDataPost.append(
              `faces[${key}][total_cost]`,
              this.faces[key]["totalCost"]
            );
            formDataPost.append(
              `faces[${key}][final_image]`,
              this.faces[key]["finalImage"]
            );
            if (
              this.faces[key].elements &&
              this.faces[key].elements.length > 0
            ) {
              for (const el of this.faces[key].elements) {
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][element_id]`,
                  el.element_id
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][name]`,
                  el.name
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][article]`,
                  el.article
                );

                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][position_x]`,
                  el.position.x
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][position_y]`,
                  el.position.y
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][width]`,
                  el.width
                );

                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][height]`,
                  el.height
                );

                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][angle]`,
                  el.angle
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][mirrored]`,
                  el.mirrored || 0
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][offsetTop]`,
                  el.offsetTop
                );

                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][offsetLeft]`,
                  el.offsetLeft
                );

                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][layer]`,
                  el.layer
                );

                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][proporcion]`,
                  el.proporcion || 0
                );

                if (el.size) {
                  formDataPost.append(
                    `faces[${key}][elements][${el.element_id}][price]`,
                    el.size.price
                  );
                  formDataPost.append(
                    `faces[${key}][elements][${el.element_id}][cost]`,
                    el.size.cost
                  );
                }
              }
            }
            if (this.faces[key].texts && this.faces[key].texts.length > 0) {
              for (const txtInd in this.faces[key].texts) {
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][text]`,
                  this.faces[key].texts[txtInd].text
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][count]`,
                  this.faces[key].texts[txtInd].count
                );

                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][angle]`,
                  this.faces[key].texts[txtInd].angle
                );

                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][offsetTop]`,
                  this.faces[key].texts[txtInd].offsetTop
                );

                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][offsetLeft]`,
                  this.faces[key].texts[txtInd].offsetLeft
                );

                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][layer]`,
                  this.faces[key].texts[txtInd].layer
                );

                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][position_x]`,
                  this.faces[key].texts[txtInd].position.x
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][position_y]`,
                  this.faces[key].texts[txtInd].position.y
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][price]`,
                  this.faces[key].texts[txtInd].price
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][cost]`,
                  this.faces[key].texts[txtInd].cost
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][total]`,
                  this.faces[key].texts[txtInd].total
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][total_cost]`,
                  this.faces[key].texts[txtInd].totalCost
                );
                if (this.faces[key].texts[txtInd].font) {
                  formDataPost.append(
                    `faces[${key}][texts][${txtInd}][font_id]`,
                    this.faces[key].texts[txtInd].font.font_id
                  );
                  formDataPost.append(
                    `faces[${key}][texts][${txtInd}][font_family]`,
                    this.faces[key].texts[txtInd].font.name
                  );
                }

                if (this.faces[key].texts[txtInd].size) {
                  formDataPost.append(
                    `faces[${key}][texts][${txtInd}][font_size]`,
                    this.faces[key].texts[txtInd].size.height
                  );
                  formDataPost.append(
                    `faces[${key}][texts][${txtInd}][cost_coefficient]`,
                    this.faces[key].texts[txtInd].size.cost_coefficient
                  );
                }
              }
            }
          }
        }

        let url = `/api/order-confirm`;

        const res = await axios.post(url, formDataPost, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (res.data && res.data.data) {
          this.$store.dispatch("clientOrder/clear");
          this.$router.push({
            name: "order-success",
            params: { order_id: res.data.data.order_id },
          });
        }
      } catch (error) {
        this.errors = error.response && error.response.data.errors;
        this.status = error.response && error.response.status;
        if (error.response) {
          const notification = {
            type: "error",
            message:
              error.response &&
              error.response.data &&
              error.response.data.message,
          };
          this.$store.dispatch("notification/add", notification, {
            root: true,
          });
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
<style scoped>
.confirm-order {
  z-index: 10;
}
.confirm-order-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: 100%;
}
.column__title {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1.1;
}
.confirm-order-content-column {
  padding-top: 20px;
  padding-bottom: 40px;
}
.confirm-order-content-column + .confirm-order-content-column {
  border-left: 1px solid #ccdfe8;
  margin-left: 15px;
  padding-left: 15px;
}
.order-faces-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.order-faces-name {
  margin-bottom: 0.5rem;
}
.order-faces-image,
.order-face-popup-image {
  border: 1px solid #c0c4d1;
  background-color: #fff;
  padding: 0.25rem;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}
.order-faces-image {
  cursor: pointer;
  width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.order-face-popup-image {
  --popup-size: min(900px, 90vw, 85vh);
  height: var(--popup-size);
  width: var(--popup-size);
  margin: auto;
}
.label-politic span {
  text-decoration: underline;
}
.order-total:first-of-type {
  border-top: 0;
  margin-top: 0;
}
.order-total.form.customer-form .form-group label {
  margin-bottom: 10px;
}
.order-total.form.customer-form .form-group + .form-group {
  margin-top: 10px;
}
.order-total.form.customer-form .form-group textarea {
  height: 70px;
}
.order_weight,
.order_prepaid {
  margin-top: 25px;
}
.confirm-order__h1,
.confirm-order__tabs {
  display: none;
}
@media screen and (max-width: 1000px) {
  .confirm-order-content-column .column__title {
    display: none;
  }
  .confirm-order__h1 {
    display: block;
    font-size: 14px;
    line-height: 1.2;
    margin-top: 15px;
    margin-bottom: 0;
  }
  .confirm-order__tabs {
    margin-top: 10px;
    display: flex;
    column-gap: 25px;
  }
  .confirm-order__tabs button {
    font-size: 13px;
    border-bottom: 3px solid #d9d9d9;
  }
  .confirm-order__tabs button.active {
    border-color: #10b982;
  }
  .confirm-order-content {
    display: flex;
    flex-direction: column;
  }
  .confirm-order-content-column {
    display: none;
  }
  .confirm-order-content-column + .confirm-order-content-column {
    border-left: none;
    margin-left: 0;
    padding-left: 0;
  }

  .confirm-order-content-column.active {
    display: block;
  }
  .order-face-popup-image {
    --popup-size: min(94vw, 85vh);
    width: var(--popup-size);
    height: var(--popup-size);
  }
}

@media screen and (max-width: 400px) {
  .order-faces-list {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>

<style>
.confirm-order-content-column .element-detail {
  flex-direction: row;
}
@media screen and (max-width: 400px) {
  .confirm-order-content-column .element-detail {
    flex-direction: column;
  }
}
</style>
